import { z } from 'zod'

export const LoadFinancialTypeAliasSchema = z.enum([
  'rate',
  'offered_rate',
  'historical_rate',
  'preferred_rate',
  'estimated_cost',
  'base_line_cost',
  'other_cost',
  'invoices_total',
  'invoices_total_excl_vat',
  'total_bills',
  'total_bills_incl_vat',
  'estimated_costs',
  'estimated_costs_total_bills',
  'gross_profit_invoices',
  'gross_profit_paid_invoices',
])

export type LoadFinancialTypeAlias = z.infer<typeof LoadFinancialTypeAliasSchema>

export const LoadFinancialCurrencyRefSchema = z.object({
  alias: z.string().transform(value => value.toUpperCase()),
  symbol: z.string(),
  title: z.string(),
})

export const LoadFinancialTypeSchema = z.object({
  alias: LoadFinancialTypeAliasSchema,
  charge_type: z.enum(['revenue', 'cost', 'estimated_revenue', 'estimated_costs']).nullable(),
  id: z.number(),
  is_active: z.boolean(),
  title: z.string(),
})

export const LoadFinancialSchema = z.object({
  amount: z.number(),
  amount_base: z.number().nullable(),
  base_currency: LoadFinancialCurrencyRefSchema.nullable(),
  created_at: z.string().nullable(),
  created_by: z.number().nullable(),
  currency: LoadFinancialCurrencyRefSchema,
  description: z.string().nullable(),
  exchange_date: z.string().nullable(),
  exchange_rate: z.string().nullable(),
  id: z.number(),
  title: z.string().nullable(),
  type: LoadFinancialTypeSchema,
})

export const LoadFinancialsSchema = LoadFinancialSchema.array()

export type LoadFinancial = z.infer<typeof LoadFinancialSchema>
export type LoadFinancials = z.infer<typeof LoadFinancialsSchema>
